/**
 * Purpose: Single source of truth for the copilot's base system prompt —
 *          the standing preamble, the app context line, the interface
 *          locale hint and the host's `systemHints`. Shared by the text
 *          chat ({@link ConversationDriver}) and the in-chat realtime voice
 *          mode so both answer under identical instructions.
 *
 * Implementation notes:
 *   - The output must stay byte-identical to what `ConversationDriver`
 *     assembled before this module existed: the text path relies on a
 *     stable prompt prefix for provider-side prompt caching.
 *   - Pure string building, no I/O — safe to call from browser and Node.
 *
 * Created: 2026-10-06 16:02
 *
 * Changelog:
 *   - 2026-10-06 16:02 — Initial version. Extracted from
 *     `ConversationDriver#assembleSystemPrompt` so the new in-chat realtime
 *     voice mode reuses the exact chat instructions.
 */
/** Standing preamble that opens every copilot system prompt. */
export const STANDING_PREAMBLE = [
    'You are an in-app assistant embedded in an Ada application.',
    'Be concise. Prefer one short paragraph; bullets only when listing.',
    'When the user asks how to do something, explain the steps using the',
    'host application’s vocabulary, not generic advice.',
    'Always reply in the language the user writes in.',
].join(' ');
/** Build the copilot's base system prompt. */
export function assembleCopilotSystemPrompt(input) {
    const parts = [STANDING_PREAMBLE, `App context: ${input.appId}.`];
    if (input.locale) {
        parts.push(`The app's interface language is "${input.locale}". ` +
            'If you cannot tell which language the user is writing in, reply in that language.');
    }
    if (input.systemHints)
        parts.push(input.systemHints);
    return parts.join('\n\n');
}
//# sourceMappingURL=system-prompt.js.map